var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86624 12.1456V18.9191C7.86418 19.1748 7.98945 19.4137 8.198 19.5518L7.86624 12.1456ZM14.591 8.59793L14.3551 9.33127L15.1253 9.31619L21.197 9.19725C21.5532 9.20202 21.8951 9.36479 22.1331 9.65195C22.384 9.95812 22.4954 10.3658 22.4333 10.7678C22.3609 11.1757 22.1124 11.5199 21.7682 11.7072L21.1094 12.0657L21.6494 12.5862C21.9808 12.9057 22.1336 13.3849 22.0444 13.8539C21.9553 14.3223 21.6406 14.7005 21.2242 14.8641L20.5002 15.1485L21.0097 15.7363C21.3434 16.1212 21.439 16.6742 21.2491 17.1596C21.0599 17.6431 20.6269 17.9618 20.1431 17.9985L19.1522 18.0738L19.7422 18.8734C20.0492 19.2896 20.0992 19.8552 19.867 20.3242C19.6359 20.7911 19.1729 21.0688 18.6842 21.0564L18.6842 21.0562H18.6702H13.0518H13.0515C12.2739 21.0567 11.5033 20.9038 10.7808 20.6053L8.50207 19.0935L8.50163 19.0932C8.45239 19.0606 8.41562 18.9982 8.41622 18.9235H8.41624V18.9191V12.175C8.4238 12.1262 8.44738 12.0844 8.47894 12.0561L8.50516 12.0326L8.52815 12.0059C9.46171 10.9222 10.34 9.78918 11.1593 8.61147L11.1595 8.61157L11.1672 8.59979C11.4136 8.22564 11.6385 7.83706 11.8408 7.43604L11.8449 7.42786L11.8488 7.41954C11.9958 7.10228 12.0919 6.76303 12.1336 6.41494C12.2478 5.52818 12.316 4.63578 12.338 3.74155C12.4507 3.64751 12.5827 3.58413 12.7222 3.55562C13.0737 3.51305 13.443 3.72907 13.8075 4.14093C14.1174 4.49109 14.3272 4.87352 14.4231 5.04834C14.4314 5.06354 14.4389 5.07716 14.4455 5.08906C14.585 5.38373 14.6835 5.69769 14.7381 6.02161L14.7393 6.02896L14.7407 6.03627C14.9081 6.8892 14.8564 7.77248 14.591 8.59793Z",
    fill: "white",
    stroke: "#027BFC",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.55,
    y: 9.88936,
    width: 4.6698,
    height: 10.8095,
    rx: 0.95,
    fill: "white",
    stroke: "#027BFC",
    strokeWidth: 1.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpBlue);
export default __webpack_public_path__ + "static/media/thumbs-up-blue.5551b5858551bde5b21d0831b50a6239.svg";
export { ForwardRef as ReactComponent };